import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'semantic-ui-react';
import * as ROUTES from '../../routes';
import { intersection } from 'lodash';

const roleCheck = (roles, allowed) => intersection(roles, allowed).length !== 0;

class SubNavigationBar extends Component {
  constructor (props) {
    super(props);
  }

  render () {
    let { activeLink } = this.props;
    const roles = Array.isArray(this.props.roles) ? this.props.roles : [];

    return (
      <Menu inverted style={{ backgroundColor: '#136444', borderRadius: 0, margin: 0 }}>
        {
          roleCheck(roles, ['client']) && <Menu.Item active={activeLink === 'inicio'} as={Link} name="inicio" to={ROUTES.DASHBOARD} />
        }
        {
          roleCheck(roles, ['client']) && <Menu.Item active={activeLink === 'reservas'} as={Link} name="mis reservas" to={ROUTES.RESERVATIONS} />
        }
        {
          roleCheck(roles, ['client']) && <Menu.Item active={activeLink === 'saldo'} as={Link} name="mi saldo" to={ROUTES.BALANCE} />
        }

        {
          roleCheck(roles, ['sysadmin']) &&
          <Menu.Menu position="right">
            <Menu.Item active={activeLink === 'usuarios'} as={Link} name="usuarios" to="/users" />
          </Menu.Menu>
        }
      </Menu>
    );
  }
}

export default SubNavigationBar;



// WEBPACK FOOTER //
// ./src/components/navigation/SubNavigationBar.jsx